enum ProjectsGroupBy {
  NONE = 'NONE',
}

export default ProjectsGroupBy;